import axios from "axios";
import { authAPI } from "services/apis.service";

// OAuth codes are single-use credentials; never ship them to logs.
export function redactAuthCode(href) {
  try {
    const url = new URL(href);
    if (url.searchParams.has("code")) url.searchParams.set("code", "REDACTED");
    return url.toString();
  } catch {
    return href;
  }
}

// additionalData is a string map on the backend.
export function stringifyValues(obj) {
  const out = {};
  Object.entries(obj || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    out[key] = typeof value === "object" ? JSON.stringify(value) : String(value);
  });
  return out;
}

function getStoredUser() {
  try {
    const raw = sessionStorage.getItem("user") || localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/**
 * Send a non-auth client event to the backend client-logs endpoint
 * (same endpoint as logAuthError). Never throws.
 *
 * @param {object} opts
 * @param {string} opts.source  e.g. "App/Startup/GetIndividualSubscriptionData"
 * @param {Error|string} [opts.error]
 * @param {string} [opts.message]  overrides error.message
 * @param {"Trace"|"Debug"|"Information"|"Warning"|"Error"|"Critical"} [opts.level]
 * @param {object} [opts.extra]  merged into additionalData
 */
export async function logClientEvent({
  source,
  error,
  message,
  level = "Error",
  extra = {},
}) {
  try {
    const safeError =
      typeof error === "string" ? { message: error } : error || {};
    const user = getStoredUser();
    const responseData = safeError?.response?.data;

    const payload = {
      level,
      message: message || safeError?.message || "Unknown Error",
      source,
      stackTrace: safeError?.stack || "",
      url: redactAuthCode(window.location.href),
      userAgent: window.navigator.userAgent,
      additionalData: stringifyValues({
        statusCode: String(safeError?.response?.status || 0),
        errorCode: safeError?.code || "",
        requestUrl: safeError?.config?.url,
        errorResponse: responseData
          ? typeof responseData === "object"
            ? JSON.stringify(responseData)
            : String(responseData)
          : "",
        userId: user?.userId,
        userEmail: user?.email,
        loginType: user?.loginType,
        online: navigator.onLine,
        visibilityState: document.visibilityState,
        timestamp: new Date().toISOString(),
        platform: window.navigator.platform,
        ...extra,
      }),
    };

    await axios.post(authAPI.logError, payload, { timeout: 10000 });
  } catch (e) {
    console.error("Failed to log client event to backend", e);
  }
}
